import React, { Component } from 'react';
import {
  PickerContainer,
  PaletteColor,
  PaletteColors,
  ColorPickerInput,
} from './StyledComponents';

import { palette } from './utils'

class Manager extends Component {
  state = {
    color: palette[0],
    hex: '#',
    error: false,
  };
  inputValue = e => {
    let value = e.target.value;
    if (value === '') {
      value = '#';
    }
    this.setState({ hex: value });
  };
  defineColor = () => {
    const isHex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(this.state.hex);
    if (!isHex) {
      this.setState({ hex: '#', error: true }, () => {
        setTimeout(() => this.setState({ error: false }), 500);
      });
    } else {
      this.props.onChange(this.state.hex);
    }
  };
  checkEnter = e => {
    if (e.key === 'Enter') {
      this.defineColor();
    }
  };
  render() {
    const { left, prop, style, onChange, colorsUsed } = this.props
    return (
      <PickerContainer width={330} left={left}>
        <PaletteColors>
          {palette.map(color => (
            <PaletteColor
              color={color}
              onClick={() => onChange(color)}
              selected={style && prop === color}
              used={colorsUsed.includes(color)}
            />
          ))}
        </PaletteColors>
        <ColorPickerInput
          error={this.state.error}
          value={this.state.hex}
          onChange={this.inputValue}
          onBlur={this.defineColor}
          onKeyDown={this.checkEnter}
        />
      </PickerContainer>
    );
  }
}

export default Manager;
